import {baseAsyncTypes} from 'actions/types'
import {combineReducers} from 'redux'
import {createDataBlockReducer} from 'helpers/reducer'
import approvals from "./approvals"
import quotes from './quotes'
import dashboard from './dashboard'
import selected from './selected'
import selector from './selector'
import recent from './recent'
import add from './add'
import bulkCloseQuotesDialog from "./bulkCloseQuotesDialog"

export default combineReducers({
  approvals,
  recent,
  quotes,
  dashboard,
  selected,
  selector,
  add,
  bulkCloseQuotesDialog,
  infoPopup: createDataBlockReducer(baseAsyncTypes.QUOTING_QUOTE_INFO_POPUP_LOAD, null, true)(),
})
